import { Component, OnInit} from '@angular/core';

import { LoadingService } from './loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {

    public show: any;

    constructor(private loaderService: LoadingService) {}

    ngOnInit() {
        this.loaderService.status.subscribe((val: boolean) => {
            this.show = val;
        });

    }
}
